import React from 'react';
import { connect } from 'react-redux';
import { selectIngredientOption } from './actions';
import { defaultIngredientOption } from 'shared/models/product';
import { track } from 'shared/models/analytic';
import { MutedBackground } from 'scy/Background';
import { SmallUppercase, SecondarySmallUppercase } from 'scy/text';
import Select from 'scy/Select';
import { textCenter, textOverflow } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './ingredients.mod.scss';

function ProductIngredients({ ingredients, sku }) {
  return (
    <MutedBackground className={styles.container}>
      <SmallUppercase
        tag="div"
        className={textCenter}
        marginClass={`${margin.top_0} ${margin.bottom_xs}`}
      >
        Choose Your Ingredients
      </SmallUppercase>
      {ingredients.map(ingredient => (
        <ConnectedIngredientSelector
          collectionSKU={sku}
          ingredient={ingredient}
          key={ingredient._id}
        />
      ))}
    </MutedBackground>
  );
}

class IngredientSelector extends React.Component {
  constructor(props) {
    super(props);
    const selectedProduct = defaultIngredientOption(props.ingredient);
    this.state = {
      selected: {
        value: { product: selectedProduct },
        label: selectedProduct.sku_id
      },
      options: this.options(props.ingredient)
    };
  }

  options(ingredient) {
    if (!ingredient.options.length) return [];
    return ingredient.options
      .map(product => ({ value: { product }, label: product.sku_id }))
      .concat(
        ingredient.required
          ? []
          : {
              value: {
                product: null,
                name: ingredient.name,
                _id: ingredient._id
              },
              label: 'none'
            }
      );
  }

  select(selected) {
    const prevProduct = this.state.selected.value.product || {};
    const nextProduct = selected.value.product || {};

    this.setState({ selected });

    const ingredient = this.props.ingredient;
    const product = selected.value.product;
    this.props.selectIngredientOption(ingredient, product);

    track('Collection Updated', {
      collection: this.props.collectionSKU,
      from: prevProduct.sku_id,
      to: nextProduct.sku_id
    });
  }

  renderValue({ value }) {
    const product = value.product;
    if (!product)
      return (
        <div className={styles.ingredientRow}>
          <div className={styles.titleContainer}>
            <SmallUppercase>{value.name}</SmallUppercase>{' '}
            <SecondarySmallUppercase>(None)</SecondarySmallUppercase>
          </div>
        </div>
      );
    return this._renderIngredientOption(product);
  }

  renderOption({ value }) {
    const product = value.product;
    if (!product)
      return (
        <div className={styles.ingredientRow}>
          <SecondarySmallUppercase>Remove Item</SecondarySmallUppercase>
        </div>
      );
    const selectedProduct = this.state.selected.value.product || {};
    const priceDiff =
      product.sku_id === selectedProduct.sku_id
        ? null
        : this.priceDiff(product, selectedProduct);
    return this._renderIngredientOption(product, priceDiff);
  }

  _renderIngredientOption(product, priceDiff = null) {
    return (
      <div className={styles.ingredientRow}>
        <img className={styles.image} src={product.image} />
        <SmallUppercase tag="div" className={styles.titleContainer}>
          {product.title}
          <SecondarySmallUppercase>
            {product.qty > 1 ? ` x${product.qty}` : ''}
          </SecondarySmallUppercase>
          <SecondarySmallUppercase tag="div" className={textOverflow}>
            {product.subtitle} | {product.volume}
          </SecondarySmallUppercase>
        </SmallUppercase>
        <SecondarySmallUppercase tag="span" className={styles.price}>
          {priceDiff ? priceDiff : null}
        </SecondarySmallUppercase>
      </div>
    );
  }

  priceDiff(product, selectedProduct) {
    const newPrice = product.price || 0;
    const selectedPrice = selectedProduct.price || 0;
    const diff = newPrice.toFixed(2) - selectedPrice.toFixed(2);
    return `${diff >= 0 ? '+' : '-'}$${Math.abs(diff).toFixed(2)}`;
  }

  render() {
    if (!this.state.options.length) return null;
    return (
      <Select
        className={styles.select}
        clearable={false}
        searchable={false}
        value={this.state.selected}
        valueRenderer={this.renderValue.bind(this)}
        options={this.state.options}
        optionRenderer={this.renderOption.bind(this)}
        onChange={option => this.select(option)}
      />
    );
  }
}

const ConnectedIngredientSelector = connect(
  state => ({
    selectedIngredients: state.product.selectedIngredients
  }),
  { selectIngredientOption }
)(IngredientSelector);

export default ProductIngredients;
